import React from "react";
import { makeStyles } from "@material-ui/core";
import { usePagination } from "@material-ui/lab";

import { getPagesList } from "./utils";
import PaginatorArrow from "./PaginatorArrow";
import PaginatorItem from "./PaginatorItem";

export default function Paginator({ pagination, category, onPageChange }) {
  const classes = useStyle();
  const pages = getPagesList(pagination);
  const { items } = usePagination({
    count: pages.length,
    page: pagination.currentPage,
  });

  if (Array.isArray(pages) && pages.length <= 1) {
    return <div className={classes.empty} />;
  }
  return (
    <nav className={classes.container}>
      <ul className={classes.paginator}>
        {items.map((item, index) => {
          const classNames = `${classes.page}${item.selected ? ` ${classes.currentPage}` : ""}`;

          if (item.type === "start-ellipsis" || item.type === "end-ellipsis") {
            return (
              <PaginatorItem
                key={index}
                className={classNames}
                category={category}
                item={item}
                onPageChange={onPageChange}
              >
                …
              </PaginatorItem>
            );
          } else if (item.type === "page") {
            return (
              <PaginatorItem
                key={index}
                className={classNames}
                category={category}
                item={item}
                onPageChange={onPageChange}
              >
                {item.page}
              </PaginatorItem>
            );
          } else {
            return (
              <PaginatorItem
                key={index}
                className={classNames}
                category={category}
                item={item}
                onPageChange={onPageChange}
              >
                <PaginatorArrow disabled={item.disabled} back={item.type === "previous"} />
              </PaginatorItem>
            );
          }
        })}
      </ul>
    </nav>
  );
}

const useStyle = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(9),
    display: "flex",
    alignItems: "center",
    margin: "auto",
    marginBottom: theme.spacing(5),
  },
  paginator: {
    display: "flex",
    margin: "0 auto",
    padding: 0,
  },
  empty: { height: 100 },
  page: {
    margin: 0,
    listStyleType: "none",
    width: 30,
    height: 30,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.grey[300],
    borderLeftWidth: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.secondary.dark,
    "&:first-child": {
      borderLeftWidth: 1,
      borderLeftStyle: "solid",
      borderLeftColor: theme.palette.grey[300],
    },
    "& a": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      color: theme.palette.secondary.dark,
      "&:hover": {
        textDecoration: "none",
      },
    },
  },
  currentPage: {
    backgroundColor: theme.palette.secondary.dark,
    "& a": {
      color: theme.palette.grey[100],
    },
  },
}));
